// removed by extract-text-webpack-plugin
module.exports = {"input":"Input__input___2Sh1s","inputLabel":"Input__inputLabel___nQolz","radio":"Input__radio___1oPWf"};


//////////////////
// WEBPACK FOOTER
// ./src/Input.css
// module id = 5
// module chunks = 0 1